// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"c87ebff1","290":"1a128e7f","347":"fba0bc27","483":"f4a1f516","716":"70333dc4","923":"049f3825"}[chunkId] + ".chunk.js";
};